// extracted by mini-css-extract-plugin
export var fullHeightState = "_45-7";
export var headerCell = "_45-1";
export var loadingStateCell = "_45-4";
export var rowWrapper = "_45-3";
export var standaloneTable = "_45-8";
export var standaloneTableWithBodyFill = "_45-9";
export var stateCell = "_45-5";
export var table = "_45-0";
export var tableBodyFiller = "_45-6";
export var white = "_45-2";